// removed by extract-text-webpack-plugin
module.exports = {"testimonialCard":"testimonialCard__2SJQW","leftCard":"leftCard__33Ui2","rightCard":"rightCard__3qwlg","cardImage":"cardImage__6_dJA","cardName":"cardName__2Na93","cardDesc":"cardDesc__Un8uO","comma":"comma__wnzpi"};


//////////////////
// WEBPACK FOOTER
// ./routes/campaign-activation/componentsVC/testimonials/testimonialCard/style.css
// module id = KH90
// module chunks = 458